import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { clarity } from "react-microsoft-clarity";
import { AinaIntroPrimer } from "./components/aina-intro";
import { router } from "./routes/router";
import { AuthProvider } from "./providers/AuthProvider";
import { MenuNavigationProvider } from "./providers/MenuNavigationProvider";
import { clarityProjectId, isClarityEnabled } from "./lib/clarityIdentity";
import "./App.css";

function App() {
  useEffect(() => {
    if (!isClarityEnabled || !clarityProjectId) {
      return;
    }
    clarity.init(clarityProjectId);
  }, []);

  return (
    <AuthProvider>
      <MenuNavigationProvider>
        <AinaIntroPrimer />
        <RouterProvider router={router} />
      </MenuNavigationProvider>
    </AuthProvider>
  );
}

export default App;
